import { debounce } from '../../common/utils/debounce';
import { renderRecommendedAccessories } from './recommended-accessories-unified';
import createLogger from '../../common/utils/logger';

const log = createLogger('CustomProducts');


// export function createProductThumbnail(baseUrl, sku, containerSelector) {
//   const container = document.querySelector(containerSelector);
//   if (!container) return null;

//   // ✅ Check if this SKU already exists
//   if (container.querySelector(`[thumbnail-data-sku="${sku}"]`)) {
//     console.warn(`Thumbnail for SKU "${sku}" already exists. Skipping.`);
//     return null;
//   }

//   // Sizes for different usages
//   const sizes = {
//     thumb: "50x50",
//     main: "500x659",
//     zoom: "1280x1280",
//     srcset: ["80w", "160w", "320w", "640w", "960w", "1280w", "1920w", "2560w"]
//   };

//   // Build URLs
//   const thumbUrl = baseUrl.replace("{:size}", sizes.thumb);
//   const mainUrl = baseUrl.replace("{:size}", sizes.main);
//   const zoomUrl = baseUrl.replace("{:size}", sizes.zoom);
//   const srcset = sizes.srcset.map(s => `${baseUrl.replace("{:size}", s)} ${s}`).join(", ");

//   // Create elements
//   const li = document.createElement("li");
//   li.className = "productView-thumbnail slick-slide slick-current slick-active";
//   li.style.width = "64px";
//   li.tabIndex = 0;
//   li.setAttribute("data-slick-index", "0");
//   li.setAttribute("aria-hidden", "false");
//   li.setAttribute("data-sku", sku); // ✅ SKU tracking

//   const a = document.createElement("a");
//   a.className = "productView-thumbnail-link";
//   a.href = mainUrl;
//   a.tabIndex = 0;
//   a.setAttribute("data-image-gallery-item", "");
//   a.setAttribute("data-image-gallery-new-image-url", mainUrl);
//   a.setAttribute("data-image-gallery-new-image-srcset", srcset);
//   a.setAttribute("data-image-gallery-zoom-image-url", zoomUrl);

//   const img = document.createElement("img");
//   img.src = thumbUrl;
//   img.alt = `Thumbnail for SKU ${sku}`;
//   img.title = `Thumbnail for SKU ${sku}`;
//   img.setAttribute("data-sizes", "auto");
//   img.setAttribute("data-sku", sku);
//   img.setAttribute("thumbnail-data-sku", sku);
//   img.srcset = srcset;
//   img.setAttribute("data-srcset", srcset);
//   img.className = "lazyautosizes lazyloaded";
//   //img.sizes = "50px";

//   // Assemble
//   a.appendChild(img);
//   li.appendChild(a);
//   //container.appendChild(li);

//   return li;
// }

// /**
//  * Hide/show <li> items inside #product-details-image-carousel by matching img[data-sku].
//  * Shows items where data-sku === provided sku; hides all others.
//  * If an <li> has no img[data-sku], it is hidden.
//  * @param {string|number} sku
//  */
// function filterCarouselBySku(sku) {
//   const expected = String(sku).trim();
//   const items = document.querySelectorAll('#product-details-image-carousel > div > div > li');

//   items.forEach(li => {
//     const img = li.querySelector('img[data-sku]');
//     const actual = img ? String(img.getAttribute('data-sku') || '').trim() : '';
//     const isMatch = actual === expected;

//     li.classList.toggle('is-hidden-product', !isMatch);
//     li.setAttribute('aria-hidden', String(!isMatch));
//   });
// }

// /** Show all items again (undo filtering). */
// function showAllCarouselItems() {
//   const items = document.querySelectorAll('#product-details-image-carousel > li');
//   items.forEach(li => {
//     li.classList.remove('is-hidden-product');
//     li.setAttribute('aria-hidden', 'false');
//   });
// }

// //Requires jQuery and Slick
// export function slickFilterBySku(sku, {
//   slickSelector = '#product-details-image-carousel',
//   imgSelector = 'img[data-sku]'
// } = {}) {
//   const expected = String(sku).trim();
//   const $slick = $('[data-slick]');

//   if (!$slick.length || typeof $slick.slick !== 'function') {
//     console.warn('Slick instance not found at', slickSelector);
//     return;
//   }

//   // First, clear any previous filters
//   $slick.slick('slickUnfilter');

//   // Do we have at least one match? (use non-cloned slides for check)
//   const hasMatch = $slick
//     .find(`.slick-slide:not(.slick-cloned) ${imgSelector}[data-sku="${expected}"]`)
//     .length > 0;

//   if (!hasMatch) {
//     // No matching thumbnails – keep all visible to avoid empty carousel
//     console.info(`No thumbnails found for SKU ${expected}; leaving carousel unfiltered.`);
//     $slick.slick('slickGoTo', 0, true);
//     return;
//   }

//   // Apply the filter
//   $slick.slick('slickFilter', function () {
//     const actual = ($(this).find(imgSelector).attr('data-sku') || '').trim();
//     return actual === expected;
//   });

//   // Snap back to the first slide after filtering
//   $slick.slick('slickGoTo', 0, true);

//   // Optional: trigger click on the first visible item so the main image syncs
//   const $firstLink = $slick.find('.slick-slide:not(.slick-cloned):visible [data-image-gallery-item]').first();
//   if ($firstLink.length) $firstLink.trigger('click');
// }

// function slickShowAll({
//   slickSelector = '#product-details-image-carousel'
// } = {}) {
//   const $slick = $(slickSelector);
//   if ($slick.length && typeof $slick.slick === 'function') {
//     $slick.slick('slickUnfilter').slick('slickGoTo', 0, true);
//   }
// }


async function getVariantProductDetails(currenVariantSku, token, options = {}) {
  // Define default options
  const {
    includeSiteSettings = true,
    includePrices = true,
    includeVariants = true,
    includeOptions = true,
    includeMetafields = true,
    metafieldNamespace = 'Custom-Product' // Default namespace
  } = options;

  // --- GraphQL Fragments (no changes here) ---

  const siteSettingsFragment = `
        settings {
            webAnalytics {
                ga4 { tagId }
                metaPixel { pixelId }
                segment { writeKey }
            }
        }
    `;

  const pricesFragment = `
        prices {
            bulkPricing {
                maximumQuantity
                minimumQuantity
                ... on BulkPricingRelativePriceDiscount { priceAdjustment }
                ... on BulkPricingFixedPriceDiscount { price }
                ... on BulkPricingPercentageDiscount { percentOff }
            }
            price { value formatted }
            retailPrice { value formatted }
            basePrice { value formatted }
        }
    `;

  const variantsFragment = `
        variants(skus: "${currenVariantSku}") {
            edges {
                node {
                    entityId
                    id
                    sku
                    prices { price { formatted value } }
                    options { edges { node { displayName entityId values { edges { node { entityId label } } } } } }
                }
            }
        }
    `;

  const optionsFragment = `
        options {
            edges {
                node {
                    displayName
                    entityId
                    isRequired
                }
            }
        }
    `;

  const metafieldsFragment = `
        metafields(namespace: "${metafieldNamespace}") {
            edges {
                node {
                    key
                    value
                    id
                    entityId
                }
            }
        }
    `;


  let siteQueryParts = [];

  // Part 1: Add site settings if requested
  if (includeSiteSettings) {
    siteQueryParts.push(siteSettingsFragment);
  }

  // Part 2: Build the product-specific parts
  let productQueryParts = [];
  if (includePrices) productQueryParts.push(pricesFragment);
  if (includeVariants) productQueryParts.push(variantsFragment);
  if (includeOptions) productQueryParts.push(optionsFragment);
  if (includeMetafields) productQueryParts.push(metafieldsFragment);

  // Part 3: If any product data is needed, construct the product query block
  if (productQueryParts.length > 0) {
    const productBlock = `
            product(sku: "${currenVariantSku}") {
                id
                name
                entityId
                sku
                showCartAction
                addToCartUrl
                ${productQueryParts.join('\n')}
            }
        `;
    siteQueryParts.push(productBlock);
  }

  // Part 4: Assemble the final query, wrapping everything in `site`
  const finalQuery = `query variantProduct {
        site {
            ${siteQueryParts.join('\n')}
        }
    }`;

  try {
    const response = await fetch('/graphql', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query: finalQuery }),
    });

    if (!response.ok) {
      // Log more details if the response is not OK
      const errorBody = await response.json();
      log.error('GraphQL request failed:', JSON.stringify(errorBody, null, 2));
      return null;
    }

    const result = await response.json();
    log.debug("GraphQL result:", result);
    return result;
  } catch (error) {
    log.error('Error fetching product details:', error);
    return null;
  }
}



/**
 * Renders and updates the custom product price area in a resilient way.
 * @param {HTMLElement|null} addToCartWrapper - Optional fallback container to insert after.
 * @param {object} variantPriceingItems - GraphQL-like product pricing object.
 * @param {number} minimumPurchaseQty - Minimum quantity for the calculation.
 * @param {object} [opts] - Optional settings.
 * @param {string} [opts.locale='en-US'] - Locale for currency formatting.
 * @param {string} [opts.currency='USD'] - Currency code for formatting.
 * @param {boolean} [opts.debug=false] - Logs diagnostics to console.
 * @returns { update: (newQty:number)=>void }|null}
 **/
function CustomProductPriceElement(
  addToCartWrapper,
  variantPriceingItems,
  minimumPurchaseQty,
  opts = {}
) {
  const { locale = 'en-US', currency = 'USD', debug = false } = opts;

  // --------- Selectors (use data attributes if possible) ---------
  // Prefer resilient hooks. If you cannot change HTML, keep your original selectors here.
  const SELECTORS = {
    productPriceContainer:
      '[data-price-container],' +
      "#product-view-inner-container > section.productView-details.buy-section.productView-inner-custom-products-bottom > div > div.productView-options-price-container",

    unitPriceWrapper:
      '[data-unit-price-span],' +
      "#product-view-inner-container > section.productView-details.buy-section.productView-inner-custom-products-bottom > div > div.productView-options-price-container > div.productView-options-Price > div:nth-child(3) > div.price-section--wrapper > div > span",
  };

  // --------- Safe lookup helpers ---------
  const productPriceContainer = document.querySelector(SELECTORS.productPriceContainer);
  if (!productPriceContainer) {
    if (debug) log.warn('[CustomProductPrice] Price container not found. Aborting render.');
    return null;
  }

  const unitPriceWrapper = document.querySelector(SELECTORS.unitPriceWrapper) || null;

  // --------- Extract and validate price data ---------
  const prices = variantPriceingItems?.data?.site?.product?.prices;
  const basePrice = Number(prices?.price?.value);

  if (!Number.isFinite(basePrice) || basePrice < 0) {
    if (debug) log.warn('[CustomProductPrice] Invalid base price.', { basePrice });
    return null;
  }

  /** @type {Array<{minimumQuantity:number, maximumQuantity:number|null, priceAdjustment?:number|null, percentOff?:number|null, price?:number|null}>} */
  const tiers = Array.isArray(prices?.bulkPricing) ? prices.bulkPricing : [];

  // --------- Create (or reuse) DOM nodes idempotently ---------
  let wrapper = document.getElementById('customPriceWrapper');
  let totalPriceSpan;

  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.id = 'customPriceWrapper';
    wrapper.classList.add('customProductPriceWrapper');

    const row = document.createElement('div');
    row.classList.add('custom-price');
    row.innerHTML = `<span class="custom-price__label">TOTAL COST: </span>`;

    totalPriceSpan = document.createElement('span');
    totalPriceSpan.id = 'customTotalPrice';
    totalPriceSpan.classList.add('custom-price__value');
    totalPriceSpan.setAttribute('aria-live', 'polite');

    row.appendChild(totalPriceSpan);
    wrapper.appendChild(row);

    // Insert after the product price container (preferred) or after fallback wrapper
    if (productPriceContainer.nextSibling) {
      productPriceContainer.parentNode.insertBefore(wrapper, productPriceContainer.nextSibling);
    } else {
      productPriceContainer.parentNode.appendChild(wrapper);
    }

    // Add spacing class once
    productPriceContainer.classList.add('price-container--with-custom');
  } else {
    totalPriceSpan = wrapper.querySelector('#customTotalPrice');
    if (!totalPriceSpan) {
      // Fallback: re-create span if missing
      totalPriceSpan = document.createElement('span');
      totalPriceSpan.id = 'customTotalPrice';
      totalPriceSpan.classList.add('custom-price__value');
      totalPriceSpan.setAttribute('aria-live', 'polite');
      wrapper.appendChild(totalPriceSpan);
    }
  }

  // --------- Helpers for safe currency math (work in cents) ---------
  const toCents = (v) => Math.round(Number(v) * 100);
  const fromCents = (cents) => cents / 100;

  /**
   * Compute best unit price based on tiers.
   * - Supports priceAdjustment, percentOff, absolute price.
   * - Handles null maximumQuantity (treated as Infinity).
   * - Picks the lowest unit price among applicable tiers.
   */
  function computeUnitCents(minQty) {
    const baseCents = toCents(basePrice);
    let bestUnitCents = baseCents;

    for (const t of tiers) {
      const minQ = Number(t?.minimumQuantity ?? 0);
      const maxQ = t?.maximumQuantity == null ? Infinity : Number(t.maximumQuantity);

      if (!(minQty >= minQ && minQty <= maxQ)) continue;

      const hasAdj = t?.priceAdjustment != null;
      const hasPct = t?.percentOff != null;
      const hasAbs = t?.price != null;

      let candidate = baseCents;

      if (hasAdj) {
        candidate = baseCents - toCents(t.priceAdjustment);
      } else if (hasPct) {
        // percentOff may be 20 (not 0.20)
        const pct = Number(t.percentOff);
        const pctFraction = pct > 1 ? pct / 100 : pct; // normalize
        const discount = Math.round(baseCents * pctFraction);
        candidate = baseCents - discount;
      } else if (hasAbs) {
        candidate = toCents(t.price);
      }

      // Clamp to >= 0
      candidate = Math.max(0, candidate);

      if (candidate < bestUnitCents) {
        bestUnitCents = candidate;
      }
    }

    return bestUnitCents;
  }

  function formatCurrency(amount) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
    } catch {
      // Fallback if Intl fails (should be rare)
      return `$${amount.toFixed(2)}`;
    }
  }

  function setDataAttributes(unitCents, minQty) {
    // Use dataset for normalized data exposure
    productPriceContainer.dataset.unitPrice = String(fromCents(unitCents));
    productPriceContainer.dataset.skuBasePrice = String(basePrice);
    productPriceContainer.dataset.minimumPurchaseQty = String(minQty);

    // Optional: this can be heavy; keep only if needed externally
    // productPriceContainer.dataset.bulkPricingTiers = JSON.stringify(tiers);

    if (unitPriceWrapper) {
      unitPriceWrapper.dataset.minimumPurchaseQty = String(minQty);
      // unitPriceWrapper.dataset.bulkPricingTiers = JSON.stringify(tiers);
    }
  }

  function updateInternal(minQty) {
    const unitCents = computeUnitCents(minQty);
    const totalCents = unitCents * Math.max(0, Math.floor(Number(minQty) || 0));

    setDataAttributes(unitCents, minQty);

    totalPriceSpan.textContent = formatCurrency(fromCents(totalCents));

    if (debug) {
      log.debug('[CustomProductPrice] calc', {
        minQty,
        unit: fromCents(unitCents),
        total: fromCents(totalCents),
        basePrice,
        tiers,
      });
    }
  }

  // Initial render
  updateInternal(minimumPurchaseQty);

  // Public API to update quantity without re-rendering DOM
  return {
    update(newQty) {
      updateInternal(newQty);
    },
  };
}
/**
 * Render shared custom product info in a resilient, style-free way.
 *
 * @param {Array} sharedCustomValue - Array of objects like:
 *   [{ key: "Label", value: "Item A, Item B", links: [{ link: "https://...", linkText: "Docs" }] }, ...]
 * @param {Object} [options]
 * @param {string} [options.containerSelector='#sharedCustomDescription'] - Where to render.
 * @param {boolean} [options.replace=true] - Replace existing content (true) or append (false).
 * @param {boolean} [options.openLinksInNewTab=true] - Open http(s) links in a new tab with safe rel.
 * @param {boolean} [options.debug=false] - Console diagnostics.
 * @returns {Object|null} - Returns a small API (e.g., count), or null if container not found.
 */
function getCustomProductSharedInfo(sharedCustomValue, options = {}, log = console) {
  const {
    containerSelector = '#sharedCustomDescription',
    replace = true,
    openLinksInNewTab = true,
    debug = false,
  } = options;

  const cycleLabel = `shared-info-cycle-${Date.now()}`;
  console.time(cycleLabel);
  log.pmark?.("cycle:start");

  // --- Container lookup ---
  log.pmark?.("container:lookup");
  const container = document.querySelector(containerSelector);
  if (!container) {
    if (debug) log.warn('[SharedCustom] Container not found:', containerSelector);
    log.pmark?.("cycle:end");
    console.timeEnd(cycleLabel);
    return null;
  }
  container.classList.add('shared-custom');
  log.pmark?.("container:found");

  // --- Normalize input ---
  log.pmark?.("normalize:start");
  const items = Array.isArray(sharedCustomValue) ? sharedCustomValue : [];
  if (items.length === 0) {
    if (replace) container.replaceChildren();
    if (debug) log.debug('[SharedCustom] No items to render.');
    log.pmark?.("normalize:end");
    log.pmark?.("cycle:end");
    console.timeEnd(cycleLabel);
    return { count: 0 };
  }
  log.pmark?.("normalize:end");

  // --- Build content ---
  log.pmark?.("build:start");
  const frag = document.createDocumentFragment();

  items.forEach((entry, idx) => {
    const section = document.createElement('div');
    section.className = 'shared-custom__section';

    // Heading
    const headingText = typeof entry?.key === 'string' ? entry.key.trim() : '';
    if (headingText) {
      const strongEl = document.createElement('strong');
      strongEl.className = 'shared-custom__heading';
      strongEl.textContent = headingText;
      section.appendChild(strongEl);
    }

    const ul = document.createElement('ul');
    ul.className = 'shared-custom__list';

    // Values
    if (typeof entry?.value === 'string') {
      entry.value
        .split(',')
        .map(v => v.trim())
        .filter(Boolean)
        .forEach(v => {
          const li = document.createElement('li');
          li.className = 'shared-custom__item';
          li.textContent = v;
          ul.appendChild(li);
        });
    }

    // Links
    if (Array.isArray(entry?.links)) {
      entry.links.forEach(linkObj => {
        const href = typeof linkObj?.link === 'string' ? linkObj.link.trim() : '';
        const linkText = typeof linkObj?.linkText === 'string' ? linkObj.linkText.trim() : href;
        if (!href) return;

        let isAllowed = false;
        try {
          const u = new URL(href, window.location.origin);
          isAllowed = ['http:', 'https:', 'mailto:', 'tel:'].includes(u.protocol);
        } catch {
          isAllowed = false;
        }
        if (!isAllowed) {
          if (debug) log.warn('[SharedCustom] Skipping unsafe URL:', href);
          return;
        }

        const li = document.createElement('li');
        li.className = 'shared-custom__item';

        const a = document.createElement('a');
        a.className = 'shared-custom__link';
        a.href = href;
        a.textContent = linkText || href;

        if (openLinksInNewTab && /^https?:/i.test(a.href)) {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        }

        li.appendChild(a);
        ul.appendChild(li);
      });
    }

    if (ul.children.length > 0) {
      section.appendChild(ul);
    }
    if (section.children.length > 0) {
      frag.appendChild(section);
    }
  });
  log.pmark?.("build:end");

  // --- DOM update ---
  log.pmark?.("dom:update:start");
  if (replace) {
    container.replaceChildren(frag);
  } else {
    container.appendChild(frag);
  }
  log.pmark?.("dom:update:end");

  // --- Finish ---
  const renderedCount = container.querySelectorAll('.shared-custom__section').length;
  if (debug) log.debug('[SharedCustom] Rendered sections:', renderedCount);

  log.pmark?.("cycle:end");
  console.timeEnd(cycleLabel);

  if (log.summary && log.getMarks) {
    const timings = log.getMarks();
    log.summary("SharedCustomInfo", timings, [
      ["container:lookup", "container:found"],
      ["normalize:start", "normalize:end"],
      ["build:start", "build:end"],
      ["dom:update:start", "dom:update:end"],
      ["cycle:start", "cycle:end"]
    ]);
  }

  return { count: renderedCount };
}

function customPriceQuantityUpdate(log = console) {
  log.group("customPriceQuantityUpdate init");
  log.pmark("init");

  // ---------- Utilities ----------
  function replaceText(el, text) {
    if (!el) {
      log.warn("replaceText called with null element");
      return;
    }
    el.replaceChildren(document.createTextNode(String(text)));
    log.debug("Replaced text in element:", el, "→", text);
  }

  function show(el, display = 'grid') {
    if (el) {
      el.style.display = display;
      log.debug("Show element:", el);
    }
  }

  function hide(el) {
    if (el) {
      el.style.display = 'none';
      log.debug("Hide element:", el);
    }
  }

  function tryParseJSON(str, fallback = []) {
    try {
      const parsed = JSON.parse(str);
      log.debug("Parsed JSON successfully:", parsed);
      return parsed;
    } catch (e) {
      log.warn("Failed to parse JSON, using fallback", { str, fallback, error: e });
      return fallback;
    }
  }

  // ---------- Element lookups ----------
  const regularInput = document.querySelector('#qty\\[\\]');
  const customInput = document.querySelector('#qty\\[\\]-custom');
  const customTotalPrice = document.getElementById('customTotalPrice');
  const customUnitPrice = document.querySelector('#productView-options-price-container');
  const alertBox = document.querySelector(
    '#add-to-cart-wrapper > div.alertBox.productAttributes-message.rca-cart-banner'
  );
  const alertMsg = alertBox?.querySelector('.alertBox-message');

  if (regularInput) log.info("Found regular input #qty[]");
  else {
    log.error("Missing #qty[] input");
    log.groupEnd();
    return;
  }

  if (customTotalPrice) log.info("Found #customTotalPrice element");
  else {
    log.error("Missing #customTotalPrice element");
    log.groupEnd();
    return;
  }

  if (customUnitPrice) log.info("Found unit price container");
  else {
    log.error("Missing unit price container");
    log.groupEnd();
    return;
  }

  if (alertBox) log.debug("AlertBox exists");
  if (customInput) log.debug("Custom input #qty[]-custom exists (unused currently)");

  log.pmark("element lookup");

  // ---------- Data from attributes ----------
  const unitPriceAttr =
    customUnitPrice.dataset?.unitPrice ??
    customUnitPrice.getAttribute('data-unit-price');
  const skuBasePriceAttr =
    customUnitPrice.dataset?.skuBasePrice ??
    customUnitPrice.getAttribute('data-sku-base-price');

  const skuBasePrice = Number(skuBasePriceAttr) || 0;
  const minimumConfiguratorUnitPrice = Number(unitPriceAttr) || skuBasePrice;
  log.info("Parsed prices", { skuBasePrice, minimumConfiguratorUnitPrice });

  const bulkPricingRaw =
    customTotalPrice.dataset?.bulkpricingTiers ??
    customTotalPrice.getAttribute('data-bulkpricing-tiers') ??
    '[]';
  const bulkPricingTiers = tryParseJSON(bulkPricingRaw, []);
  log.info("Bulk pricing tiers loaded:", bulkPricingTiers.length);

  const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  // ---------- Handler ----------
  function handleQuantityInput(event) {
    this.value = this.value.replace(/\D+/g, '');
    const minQuantity = Number(this.dataset.quantityMin) || 1;
    const currentQuantity = Number(this.value) || 0;
    log.debug("Quantity input changed", { currentQuantity, minQuantity });

    if (currentQuantity < minQuantity) {
      event?.preventDefault?.();
      if (alertBox && alertMsg) {
        const minError =
          this.getAttribute('data-quantity-min-error') ||
          'Quantity is below the minimum.';
        replaceText(alertMsg, minError);
        show(alertBox, 'grid');
        log.warn("Quantity below minimum → showing alert", { minQuantity });
      }
      this.focus();
    } else {
      hide(alertBox);
    }

    const qty = currentQuantity;
    if (qty <= 0 || !Number.isFinite(qty)) {
      replaceText(customUnitPrice, `${currency.format(skuBasePrice)} ea.`);
      replaceText(customTotalPrice, currency.format(0));
      log.debug("Invalid/zero quantity → reset pricing");
      log.pmark("pricing calculation");
      log.pmark("DOM update");
      return;
    }

    let tierUnitPrice = 0;
    for (const item of bulkPricingTiers) {
      const minQ = Number(item.minimumQuantity) || 0;
      const maxQ = item.maximumQuantity != null ? Number(item.maximumQuantity) : Infinity;

      if (qty >= minQ && qty <= maxQ) {
        if (item.priceAdjustment != null) {
          tierUnitPrice = skuBasePrice - Number(item.priceAdjustment);
          log.info("Matched bulk tier by priceAdjustment", { item, tierUnitPrice });
        } else if (item.percentOff != null) {
          const discountPercent = Number(item.percentOff) * 0.01;
          tierUnitPrice = skuBasePrice - skuBasePrice * discountPercent;
          log.info("Matched bulk tier by percentOff", { item, tierUnitPrice });
        } else if (item.price != null) {
          tierUnitPrice = Number(item.price);
          log.info("Matched bulk tier by new price", { item, tierUnitPrice });
        }
        break;
      }
    }

    if (!tierUnitPrice || !Number.isFinite(tierUnitPrice)) {
      tierUnitPrice = skuBasePrice || minimumConfiguratorUnitPrice || 0;
      log.debug("No bulk tier match → fallback to base/min configurator price", {
        tierUnitPrice,
      });
    }

    log.pmark("pricing calculation");

    const totalPrice = qty * tierUnitPrice;
    replaceText(customUnitPrice, `${currency.format(tierUnitPrice)} ea.`);
    replaceText(customTotalPrice, currency.format(totalPrice));
    log.info("Updated pricing", { qty, tierUnitPrice, totalPrice });

    log.pmark("DOM update");
  }

  // ---------- Wire up ----------
  regularInput.removeEventListener('input', handleQuantityInput);
  regularInput.addEventListener('input', handleQuantityInput);
  log.info("Wired quantity input handler");

  log.pmark("done");
  log.groupEnd();
}




// ---------- Helpers ----------
// --- DOM helpers ---
const qs = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

function replaceText(el, text) {
  if (!el) return;
  el.replaceChildren(document.createTextNode(String(text)));
}

function isValidJson(str) {
  if (typeof str !== 'string') return false;
  try { JSON.parse(str); return true; } catch { return false; }
}

function loadCustomProductMetafields(variantPricingItems, token, log = console) {
  const cycleLabel = `metafields-cycle-${Date.now()}`;
  console.time(cycleLabel);
  log.pmark?.("cycle:start");

  const edges = variantPricingItems?.data?.site?.product?.metafields?.edges;
  const selectedSku = variantPricingItems?.data?.site?.product?.sku;
  if (!Array.isArray(edges) || edges.length === 0) {
    console.timeEnd(cycleLabel);
    return;
  }

  for (const edge of edges) {
    const key = edge?.node?.key;
    const value = edge?.node?.value;

    if (key === "Shared" && value && isValidJson(value)) {
      log.pmark?.("shared:start");
      try {
        const parsed = JSON.parse(value);
        getCustomProductSharedInfo(parsed,log);
      } catch (e) {
        log.warn("[loadCustomProductMetafields] Failed to parse Shared metafield JSON:", e);
      }
      log.pmark?.("shared:end");
    }

    if (key === "Details" && value && isValidJson(value)) {
      log.pmark?.("details:start");
      try {
        const parsed = JSON.parse(value);
        getProductDetailsInfo(parsed, selectedSku, token, log);
      } catch (e) {
        log.warn("[loadCustomProductMetafields] Failed to parse Details metafield JSON:", e);
      }
      log.pmark?.("details:end");
    }

    if (key === "Price" && value && isValidJson(value)) {
      log.pmark?.("price:start");
      try {
        //const parsed = JSON.parse(value);
        customPriceQuantityUpdate(log);
      } catch (e) {
        log.warn("[loadCustomProductMetafields] Failed to process Price metafield:", e);
      }
      log.pmark?.("price:end");
    }
  }

  log.pmark?.("cycle:end");
  console.timeEnd(cycleLabel);

  // Aggregate timings
  if (log.summary && log.getMarks) {
    const timings = log.getMarks();
    log.summary("MetafieldsCycle", timings, [
      ["shared:start", "shared:end"],
      ["details:start", "details:end"],
      ["price:start", "price:end"],
      ["cycle:start", "cycle:end"]
    ]);
  }
}

function getProductDetailsInfo(detailsCustomValue, selectedSku, token) {
  const NS = '[getPDI]';

  // Validate inputs early
  if (!selectedSku) {
    log.warn(`${NS} missing selectedSku`);
    return;
  }
  const headerName = document.getElementById('product-details-header-name');
  const product = detailsCustomValue?.skuSpecificData?.[selectedSku];

  if (!product) {
    log.warn(`${NS} no product details for SKU`, selectedSku);
    return;
  }

  // Update header
  if (headerName && product.displayName) {
    headerName.textContent = product.displayName;
  }

  // Accessories (variant-specific)
  const hasAccessories = Array.isArray(product.accessories) && product.accessories.length > 0;
  if (hasAccessories) {
    __recAccInvoker(product.accessories, token);
  } else {
    // If this variant has no accessories, clear the section and optionally show originals back
    const accEl = document.getElementById('recommended_accessories');
    if (accEl) {
      accEl.innerHTML = '';
      delete accEl.dataset.renderedFor; // reset signature so future variants can render
    }
    // If you hide "originals" elsewhere, you might want to show them again for variants with none
    document.querySelectorAll('[recommended-original]').forEach(el => (el.style.display = ''));
    log.debug(`${NS} no accessories for SKU`, selectedSku);
  }

  // Short description (remove old SKU-specific, add new ones)
  const shortDescriptionUl = document.querySelector('#product-details-short-description');
  if (shortDescriptionUl) {
    // Remove old SKU-specific <li>
    shortDescriptionUl.querySelectorAll('li[data-sku]').forEach(li => li.remove());

    // Normalize shortDescription into array
    const shortDescriptions = Array.isArray(product.shortDescription)
      ? product.shortDescription
      : (product.shortDescription ? [product.shortDescription] : []);

    shortDescriptions.forEach(desc => {
      if (desc && desc.trim() !== '') {
        const li = document.createElement('li');
        li.textContent = desc;
        li.setAttribute('data-sku', selectedSku);
        shortDescriptionUl.appendChild(li);
      }
    });
  }

  // Long description (remove old SKU-specific, add new ones)
  const longDescriptionAdditionalText = document.querySelector('#productDetails_description_text');
  if (longDescriptionAdditionalText) {
    // Remove old SKU-specific nodes
    longDescriptionAdditionalText.querySelectorAll('[data-sku]').forEach(el => el.remove());

    // Normalize longDescription into array
    const longDescriptions = Array.isArray(product.longDescription)
      ? product.longDescription
      : (product.longDescription ? [product.longDescription] : []);

    longDescriptions.forEach(htmlBlock => {
      if (htmlBlock && htmlBlock.trim() !== '') {
        const div = document.createElement('div');
        // NOTE: If htmlBlock can come from an untrusted source, sanitize it before assigning innerHTML.
        div.innerHTML = htmlBlock;
        div.setAttribute('data-sku', selectedSku);
        longDescriptionAdditionalText.appendChild(div);
      }
    });
  }

  console.debug(`${NS} updated for`, { selectedSku, hasAccessories });
}


// Put once at module/global scope
const __recAccInvoker = (() => {
  let timer = null;
  const NS = '[getPDI→recAcc]';

  return function invoke(accessories, token) {
    
    const acc = document.getElementById('recommended_accessories');
    const dataIds = acc?.getAttribute('data-ids') || null;
    // --- Normalize to an ARRAY of strings (handles Array, String, Set gracefully) ---
    let items;
    if (Array.isArray(accessories)) {
      items = accessories.slice();
    } else if (typeof accessories === 'string') {
      items = accessories.split(',');
    } else if (accessories && typeof accessories[Symbol.iterator] === 'function') {
      // Handles Set or any iterable
      items = Array.from(accessories);
    } else {
      items = [];
    }

    items = items.map(s => String(s).trim()).filter(Boolean);
    const uniq = Array.from(new Set(items));        // de‑dupe but keep as ARRAY
    const sig  = uniq.join('|');                    // ALWAYS a STRING

    // Optional visibility log
    // console.debug(`${NS} normalized`, { type: Object.prototype.toString.call(accessories), uniq, sig });

    // Skip only if we already have real cards (not just heading)
    const accEl = document.getElementById('recommended_accessories');
    if (accEl && accEl.dataset.renderedFor === sig && accEl.querySelector('.accessory')) {
      log.debug(`${NS} same signature already rendered → skip`, { sig });
      return;
    }

    clearTimeout(timer);
    timer = setTimeout(() => {
      try {
        // Use unified renderer instead of local implementation
        // Get orientation from theme settings (available globally via window.stencilBootstrap context)
        const orientation = window.__stencilThemeSettings?.['recommended-accessories-display-direction'] || 'vertical';

        renderRecommendedAccessories({
          accessories: uniq, // Pass the ARRAY from metafields
          dataIds: dataIds, // No fallback needed, metafields are primary
          token: token,
          orientation: orientation,
          context: null
        }).then(result => {
          if (result.ok) {
            console.log(`${NS} ${result.reason}`, result);
          } else {
            log.warn(`${NS} failed: ${result.reason}`, result);
          }
        }).catch(err => {
          console.error(`${NS} error:`, err);
        });
      } catch (e) {
        console.error(`${NS} recommendedAccessories threw`, e);
      }
    }, 80);
  };
})();


  // ---------- 3) Add-to-cart wrapper + min qty ----------
function CreateArtifiAddToCartButtonBigCommerceStyle(element, variantPricingItems, log = console) {
  log.group("CreateArtifiAddToCartButtonBigCommerceStyle init");
  function createAddToCartButton(siblingElement) {
    // Check if button already exists
    const existingButton = document.getElementById('artifi-addtocart');
    
    if (existingButton) {
      console.log('Add to Cart button already exists');
      return existingButton;
    }
    
    // Create the button if it doesn't exist
    const button = document.createElement('input');
    
    button.id = 'artifi-addtocart';
    button.type = 'button';
    button.className = 'button button--primary';
    button.style.display = 'block';
    button.value = 'Add to Cart';
    button.setAttribute('add-to-cart-custom', 'true');
    button.onclick = triggerAddToCartEventArtifi;
    
    // Insert after the specified sibling element
    if (siblingElement) {
      siblingElement.insertAdjacentElement('afterend', button);
    } else {
      console.warn('No sibling element provided for Add to Cart button');
    }
    
    return button;
  }
  // Prefer the custom wrapper; fallback to original
  const addToCartWrapper =
    document.getElementById('add-to-cart-wrapper-custom') ||
    document.getElementById('add-to-cart-wrapper');
  if (addToCartWrapper) {
    log.info("Add to cart wrapper found:", addToCartWrapper.id);
  } else {
    log.warn("No add-to-cart wrapper found");
  }

  const qtyInput = document.querySelector('#qty\\[\\]');
  if (qtyInput) {
    log.info("Quantity input found");
  } else {
    log.warn("No quantity input found");
  }

  // Read minimumQty from Price metafield
  let minimumPurchaseQty = 1;
  const edges = variantPricingItems?.data?.site?.product?.metafields?.edges;
  if (Array.isArray(edges) && edges.length > 0) {
    log.debug(`Found ${edges.length} metafield edges`);
    for (const edge of edges) {
      const key = edge?.node?.key;
      const value = edge?.node?.value;
      if (key === 'Price' && value && isValidJson(value)) {
        try {
          const arr = JSON.parse(value);
          log.debug("Parsed Price metafield value", arr);
          if (Array.isArray(arr)) {
            const rec = arr.find(x => x?.key === 'minimumQty');
            const numericMin = Number(rec?.value);
            if (Number.isFinite(numericMin) && numericMin > 0) {
              minimumPurchaseQty = numericMin;
              log.info("Minimum purchase quantity set from metafield:", minimumPurchaseQty);
            } else {
              log.debug("No valid minimumQty found in Price metafield");
            }
          }
        } catch (e) {
          log.warn("Failed to parse Price metafield", e);
        }
      }
    }
  } else {
    log.debug("No metafield edges found, using default minimum qty");
  }

  // Ensure an alert box exists in the active wrapper
  if (addToCartWrapper) {
    let alertBox = addToCartWrapper.querySelector('.alertBox.productAttributes-message.rca-cart-banner');
    if (!alertBox) {
      alertBox = document.createElement('div');
      alertBox.className = 'alertBox productAttributes-message rca-cart-banner';
      alertBox.style.display = 'none';
      const msg = document.createElement('p');
      msg.className = 'alertBox-message';
      alertBox.replaceChildren(msg); // replace, not append
      addToCartWrapper.prepend(alertBox);
      log.info("Created new alertBox inside wrapper");
    } else {
      let msg = alertBox.querySelector('.alertBox-message');
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'alertBox-message';
        alertBox.appendChild(msg);
        log.info("Created missing .alertBox-message inside existing alertBox");
      } else {
        log.debug("AlertBox already existed with message element");
      }
    }
  }

  // Apply min qty to the input
  if (qtyInput) {
    qtyInput.value = String(minimumPurchaseQty);
    qtyInput.min = String(minimumPurchaseQty);
    qtyInput.dataset.quantityMin = String(minimumPurchaseQty);
    qtyInput.setAttribute('data-quantity-min-error', `The minimum purchasable quantity is ${minimumPurchaseQty}`);
    qtyInput.setAttribute('pattern', '[0-9]*');
    qtyInput.setAttribute('aria-live', 'polite');
    log.info("Applied minimum quantity to qtyInput:", minimumPurchaseQty);
  }

  // Style/hook the add-to-cart button
  const addToCartInput = document.querySelector('#form-action-addToCart');
  if (addToCartInput) {
    addToCartInput.setAttribute('style', 'display: block;');
    addToCartInput.setAttribute('onclick', 'triggerAddToCartEventArtifi()');
    addToCartInput.classList.add('button', 'button--primary');
    addToCartInput.setAttribute('style', 'display: none;');
    log.info("Styled and hooked add-to-cart button");

    createAddToCartButton(addToCartInput);

  } else {
    log.warn("No add-to-cart button found");
  }

  const elements = document.querySelectorAll("#artifi-personalize-button-container > div");
  if (elements && elements.length > 0) {
    elements.forEach(el => {
      if (el && el.style) {
        el.setAttribute('style', 'display: none;');
      }
    });
    log.info(`Hid ${elements.length} personalize-button elements`);
  } else {
    log.debug("No personalize-button elements found");
  }

  // Let your renderer populate; ensure *inside it* you clear any container before appending.
  if (typeof CustomProductPriceElement === 'function' && addToCartWrapper) {
    CustomProductPriceElement(addToCartWrapper, variantPricingItems, minimumPurchaseQty);
    log.info("CustomProductPriceElement invoked");
  } else {
    log.debug("CustomProductPriceElement not available or no wrapper");
  }

  // Kick initial calc so UI shows correct totals immediately
  if (qtyInput) {
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    log.debug("Dispatched input event on qtyInput to trigger recalculation");
  }

  log.groupEnd();
}

  /**
   * Parse metaFieldArray parameter into a normalized object keyed by metafield key names.
   *
   * @param {Array} metaFieldArray - GraphQL edges array with node.key and node.value
   * @returns {{ usable: boolean, data: Object }} - usable indicates if required keys are present
   *
   * Expected structure:
   * [
   *   { node: { key: "Price", value: "[{\"key\":\"minimumQty\",\"value\":\"1\"}]" }, cursor: "..." },
   *   { node: { key: "Shared", value: "[...]" }, cursor: "..." }
   * ]
   *
   * Normalized output:
   * {
   *   usable: true,
   *   data: {
   *     Price: [{ key: "minimumQty", value: "1" }],
   *     Shared: [...]
   *   }
   * }
   *
   * Required keys for pricing: Price
   * Fallback to getVariantProductDetails when usable === false
   */
  function parseMetaFieldArray(metaFieldArray) {
    // Early return if invalid input
    if (!Array.isArray(metaFieldArray) || metaFieldArray.length === 0) {
      return { usable: false, data: {} };
    }

    const out = {};
    let parseFailures = 0;

    for (const edge of metaFieldArray) {
      const key = edge?.node?.key;
      const raw = edge?.node?.value;

      // Skip entries without a key
      if (!key) continue;

      // Attempt to parse node.value as JSON
      let parsed = raw;
      if (typeof raw === 'string' && raw.trim().length > 0) {
        try {
          const maybe = JSON.parse(raw);
          parsed = maybe;
        } catch (e) {
          // Keep raw string if JSON parsing fails
          parseFailures++;
        }
      }

      out[key] = parsed;
    }

    // Determine usability - we need at least the Price key for pricing functionality
    // Additional keys like Shared, Details, Shipping, etc. are optional
    const usable = Boolean(out.Price);

    if (parseFailures > 0) {
      console.warn(`[parseMetaFieldArray] Failed to parse ${parseFailures} metafield value(s) as JSON`);
    }

    return { usable, data: out };
  }

  async function configuratorVariantPriceUpdate(currentVariantSku, token, variantImageUrl, metaFieldArray = null) {
    const log = createLogger('configuratorVariantPriceUpdate', currentVariantSku || 'no-sku');
    log.group('start');
    try {
      log.pmark('start', { sku: currentVariantSku });

      // Attempt to use metaFieldArray if provided, otherwise fallback to API fetch
      const parsed = parseMetaFieldArray(metaFieldArray);
      let data;
      let metafields;

      if (parsed.usable) {
        log.info('Using provided metaFieldArray', { keys: Object.keys(parsed.data) });

        // Construct a data structure that mimics getVariantProductDetails response
        // This allows the rest of the function to work unchanged
        data = await getVariantProductDetails(currentVariantSku, token);

        // Replace metafields with our parsed data, converted back to edges format
        const syntheticEdges = Object.entries(parsed.data).map(([key, value]) => ({
          node: {
            key,
            value: typeof value === 'string' ? value : JSON.stringify(value)
          }
        }));

        metafields = syntheticEdges;

        // Update the data structure to use our synthetic edges
        if (data?.data?.site?.product) {
          data.data.site.product.metafields = { edges: syntheticEdges };
        }
      } else {
        log.info('metaFieldArray not usable, fetching via getVariantProductDetails');
        data = await getVariantProductDetails(currentVariantSku, token);
        metafields = data?.data?.site?.product?.metafields?.edges || [];
      }

      if (metafields.length === 0) {
        log.info('no metafields for sku', { sku: currentVariantSku });
        return;
      }

      const keys = metafields.map(edge => edge.node?.key);

      const hasPriceMetaField = keys.includes('Price');
      const hasSharedMetaField = keys.includes('Shared');

      // You can add more checks like this:
      const hasShippingMetaField = keys.includes('Shipping');
      const hasPrintAreasMetaField = keys.includes('Print Areas');
      //const hasDetails = keys.includes('Details');

      log.info('metafield presence', { hasPriceMetaField, hasSharedMetaField, hasShippingMetaField, hasPrintAreasMetaField });

      if (hasPriceMetaField === true || hasSharedMetaField === true) {
      // Hide/adjust surrounding UI (FIXED: real '>' combinators)
      $$('#data-product-option-change-form > .show-selected-option')
        .forEach(el => { el.style.display = 'none'; });

      qs("#bigcommerce-artifi-iframe-container > div:nth-child(2)")?.setAttribute('style', 'display:none;');
      qs('#productView-images-container')?.setAttribute('style', 'display:none;');
      qs('.productView-info')?.setAttribute('style', 'display:none;');
      qs('#productView-details-price-header')?.setAttribute('style', 'display:none;');
      const artifiCloseButton = document.getElementById("bigcommerce-artifi-popup-header-close-button");
      if (artifiCloseButton) {
        artifiCloseButton.setAttribute('style', 'display: none;');
      }

      const elements = document.querySelectorAll("#artifi-personalize-button-container > div");

      if (elements && elements.length > 0) {
        elements.forEach(el => {
          if (el && el.style) {
            el.setAttribute('style', 'display: none;');
          }
        });
      }
      const oldEl = qs('.productView-options');
        if (!oldEl) {
          log.warn('Missing .productView-options container');
          return;
        }

      // Host container (idempotent)
      const hostId = 'artifi-custom-product-meta-data';
      let host = document.getElementById(hostId);
      if (!host) {
        host = document.createElement('div');
        host.id = hostId;
        host.classList.add('artifi-custom-product-details');
        oldEl.appendChild(host);
      } else {
        host.replaceChildren(); // replace, not append
      }

      // Build structure
      const configContainer = document.getElementById('bigcommerce-artifi-iframe-container');
      configContainer?.classList.add('bigcommerce-artifi-iframe-container');
      configContainer?.setAttribute('style', 'visibility: visible;');

      const header = document.createElement('div');
      header.id = 'custom-product-header';
      header.style.margin = '15px';
      header.style.fontSize = '20px';
      header.dataset.productId = currentVariantSku;

      const headerPrice = document.createElement('span');
      headerPrice.id = 'header-price';
      headerPrice.className = 'price price--withoutTax price-primary';
      headerPrice.style.float = 'right';

      const bulkPricingWrapper = document.createElement('div');
      bulkPricingWrapper.id = 'custom-bulk-pricing-wrapper';
      //bulkPricingWrapper.style.display = 'none';

      const unitAndTotalPriceDiv = document.createElement('div');
      unitAndTotalPriceDiv.id = 'customProductPriceWrapper';

      // Price nodes expected by the qty updater
      const unitEl = document.createElement('div');
      unitEl.id = 'customUnitPrice';  // data attributes set later
      const totalEl = document.createElement('div');
      totalEl.id = 'customTotalPrice'; // data-bulkpricing-tiers set later
      unitAndTotalPriceDiv.appendChild(unitEl);
      unitAndTotalPriceDiv.appendChild(totalEl);

      const bulkList = document.createElement('ul');
      bulkList.id = 'custom-bulk-pricing-list';

      //const addToCartWrapper = document.createElement('div');
      // addToCartWrapper.id = 'add-to-cart-wrapper-custom';
      // Object.assign(addToCartWrapper.style, {
      //   display: 'grid',
      //   gridGap: '12px',
      //   gridTemplateColumns: '50px 1fr',
      //   alignItems: 'flex-end',
      //   marginBottom: '1rem',
      // });
      const originalCart = document.querySelector('#form-action-addToCart');

      if (originalCart != null) {
        originalCart.setAttribute('add-to-cart-custom', 'true');
      }

      const sharedCustomDiv = document.createElement('div');
      sharedCustomDiv.id = 'sharedCustomDescription';

      // Assemble into host
      host.appendChild(header);
      host.appendChild(bulkPricingWrapper);
      //host.appendChild(addToCartWrapper);
      host.appendChild(sharedCustomDiv);
      bulkPricingWrapper.appendChild(unitAndTotalPriceDiv);
      bulkPricingWrapper.appendChild(bulkList);

      // Ensure product view visible
      const productViewContainerSection = document.getElementById('product-view-section');
      if (productViewContainerSection) productViewContainerSection.style.display = 'block';

      // Populate from data
      const product = data?.data?.site?.product;
      const prices = product?.prices;
      const hasBasePrice = prices?.price?.value != null;
      const variantPriceStart = data?.data?.site?.product?.variants?.edges?.[0]?.node?.prices?.price?.value



      const subscribeButton = document.querySelector('.rca-button-right');
      let variantPrice = variantPriceStart;

      const isSubscribed = subscribeButton?.classList.contains('rca-subscription-form__button--selected');

      const subscriptionDiscountDiv = document.querySelector('#sub-discount-price');
      let discount = null;
      if (subscriptionDiscountDiv) {

        discount = parseFloat(subscriptionDiscountDiv.dataset.subDiscount);
      }


      variantPrice = Number(discount) && isSubscribed ? variantPriceStart * (1 + (discount / 100)) : variantPriceStart;

      if (!product || !hasBasePrice) {
        log.warn('Product or base price missing', { product });
        return;
      }

      const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      // Header content (SKU + header price)
      replaceText(header, `SKU: ${product.sku}  `);
      header.appendChild(headerPrice);
      const basePrice = Number(variantPrice) ? Number(variantPrice) : Number(prices.price.value);
      replaceText(headerPrice, currency.format(basePrice));

      // Data attributes for qty updater
      unitEl.dataset.unitPrice = String(basePrice);
      unitEl.dataset.skuBasePrice = String(basePrice);

      const tiers = Array.isArray(prices.bulkPricing) ? prices.bulkPricing : [];
      totalEl.dataset.bulkpricingTiers = JSON.stringify(tiers);

      // Bulk pricing list (replace content)
      if (tiers.length > 0) {
        bulkPricingWrapper.style.display = 'block';
        bulkList.replaceChildren();
        const frag = document.createDocumentFragment();

        for (const item of tiers) {
          const li = document.createElement('li');
          li.style.margin = '5px';

          const { minimumQuantity, maximumQuantity, priceAdjustment, percentOff, price } = item;
          const rangeText = maximumQuantity != null
            ? `${minimumQuantity} - ${maximumQuantity}`
            : `${minimumQuantity}+`;

          let tierUnit = basePrice;
          if (priceAdjustment != null) {
            tierUnit = basePrice - Number(priceAdjustment);
          } else if (percentOff != null) {
            tierUnit = basePrice * (1 - Number(percentOff) * 0.01);
          } else if (price != null) {
            tierUnit = Number(price);
          }

          const priceSpan = document.createElement('span');
          priceSpan.style.float = 'right';

          replaceText(li, rangeText + ' ');
          replaceText(priceSpan, `${currency.format(tierUnit)} ea.`);
          li.appendChild(priceSpan);
          frag.appendChild(li);
        }
        bulkList.appendChild(frag);
      } else {
        bulkPricingWrapper.style.display = 'none';
      }

      //Recharge
      //   // The element you want to watch
      // const subscribeProductButton = document.querySelector(
      //   "#data-product-option-change-form > span > div > span > label.rca-subscription-form__buttons-type.rca-subscription-form__buttons > span:nth-child(2) > label"
      // );

      // // The SKU source element
      // const skuElement = document.querySelector("#custom-product-header");

      // if (subscribeProductButton && skuElement) {
      //   // Use a unique property flag to prevent double-binding
      //   if (!subscribeProductButton.dataset.listenerAttached) {
      //     subscribeProductButton.addEventListener("click", () => {
      //       // Prefer the data attribute, fallback to parsing text
      //       let currentVariantSku =
      //         skuElement.getAttribute("data-product-id") ||
      //         skuElement.textContent.replace("SKU:", "").trim();

      //       configuratorVariantPriceUpdate(currentVariantSku);
      //     });

      //     // Mark it so we don't attach the same listener again
      //     subscribeProductButton.dataset.listenerAttached = "true";
      //     console.log("Click listener attached to subscription option label");
      //   }
      // } else {
      //   console.warn("Target element or SKU element not found in DOM.");
      // }

      // const oneTimePurchase = document.querySelector(
      //   "#data-product-option-change-form > span > div > span > label.rca-subscription-form__buttons-type.rca-subscription-form__buttons > span:nth-child(1) > label"
      // );

      // if (oneTimePurchase && skuElement) {
      //   // Use a unique property flag to prevent double-binding
      //   if (!oneTimePurchase.dataset.listenerAttached) {
      //     oneTimePurchase.addEventListener("click", () => {
      //       // Prefer the data attribute, fallback to parsing text
      //       let currentVariantSku =
      //         skuElement.getAttribute("data-product-id") ||
      //         skuElement.textContent.replace("SKU:", "").trim();

      //       configuratorVariantPriceUpdate(currentVariantSku);
      //     });

      //     // Mark it so we don't attach the same listener again
      //     oneTimePurchase.dataset.listenerAttached = "true";
      //     console.log("Click listener attached to subscription option label");
      //   }
      // } else {
      //   console.warn("Target element or SKU element not found in DOM.");
      // }


      CreateArtifiAddToCartButtonBigCommerceStyle(host, data,log);



      customPriceQuantityUpdate(log);
    }
    loadCustomProductMetafields(data, token, log);
    } catch (err) {
      // Ensure we log unexpected errors from this function
      try { log.error('uncaught error', err); } catch (e) { console.error('logger error', e); }
      throw err;
    } finally {
      try { log.groupEnd(); } catch (e) { /* ignore logging errors */ }
    }

    //   document.querySelector("#productView-images-container > div > figure > div > a > img")?.setAttribute('data-sku', currentVariantSku);

    //  const $slick = $('[data-slick]');
    // const newThumbnail = createProductThumbnail(variantImageUrl, currentVariantSku, "#product-details-image-carousel > div > div > li");
    // if ($slick.length && newThumbnail) {
    //   // Add as a new slide at the beginning (index 0)
    //   $slick.slick('slickAdd', newThumbnail, 0, true);
    // }


    //filterCarouselBySku(currentVariantSku);
    //slickFilterBySku(currentVariantSku);
  }
  // These should both resolve and render:
// __recAccInvoker(['92323','92326'], window.__bcToken);

// // Simulate someone passing a Set:
// __recAccInvoker(new Set(['92323','92326']), window.__bcToken);

// // Simulate comma string:
// __recAccInvoker('92323,92326', window.__bcToken);

// // Signature must always be a string like "92323|92326"
// console.log(document.getElementById('recommended_accessories')?.dataset?.renderedFor);

  //const REG = window.__recAccREG;
  export const debouncedConfiguratorVariantPriceUpdate = debounce(configuratorVariantPriceUpdate, 100, 'configuratorVariantPriceUpdate');
